import { AppState } from 'store';
import { EMPTY_STRING } from 'common';
import { createSelector } from 'reselect';
import { formValueSelector } from 'redux-form';
import { NYC_DB_FORM_NAME, Tabs } from 'pages/Search/SearchForm/consts';

export const usernameSelector = ({ login: { user } }: AppState) =>
  (user && user.name) || EMPTY_STRING;

export const loadingSelector =
  (propertyName: string) =>
  ({ [propertyName]: { loading } }: any): boolean =>
    loading;

export const loginSelector = createSelector(
  (state: AppState) => state.login,
  (login) => login,
);

export const tabSelector = createSelector(
  (state: AppState) => formValueSelector(NYC_DB_FORM_NAME)(state, 'tab'),
  (tabName) => tabName,
);

export const getDataTypeName = (tabName: string) => {
  switch (tabName) {
    case Tabs.Property: {
      return 'propertyData';
    }
    case Tabs.Name: {
      return 'nameData';
    }
    case Tabs.Other: {
      return 'otherData';
    }
    case Tabs.Multi: {
      return 'multiData';
    }
    default: {
      return 'propertyData';
    }
  }
};
